module.exports = __webpack_public_path__ + "img/sharebut.078773e8.png";